import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Target, Heart, Zap, Users } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import translations from '../i18n/translations';
import './About.css';

const valueIcons = [<Target size={22} />, <Heart size={22} />, <Zap size={22} />, <Users size={22} />];
const teamColors = ['#0077ff', '#00d4ff', '#00e676', '#ab47bc', '#ff6b6b', '#ffd600'];

export default function About() {
  const { lang } = useLang();
  const t = translations[lang].about;

  return (
    <div className="about">
      <section className="page-hero">
        <div className="page-hero__orb" />
        <div className="container">
          <span className="section-tag">{t.tag}</span>
          <h1 className="page-hero__title">
            {t.title1}<br /><span className="gradient-text">{t.title2}</span>
          </h1>
          <p className="page-hero__desc">{t.desc}</p>
        </div>
      </section>

      <section className="story section">
        <div className="container story__inner">
          <div className="story__text">
            <span className="section-tag">{t.storyTag}</span>
            <h2 className="section-title">
              {t.storyTitle1}<br /><span className="gradient-text">{t.storyTitle2}</span>
            </h2>
            <p>{t.storyP1}</p>
            <p>{t.storyP2}</p>
            <p>{t.storyP3}</p>
          </div>
          <div className="story__milestones">
            {t.milestones.map((m, i) => (
              <div key={i} className="milestone">
                <div className="milestone__year">{m.year}</div>
                <div className="milestone__event">{m.event}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="values section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">{t.valuesTag}</span>
            <h2 className="section-title">
              {t.valuesTitle1} <span className="gradient-text">{t.valuesTitle2}</span>
            </h2>
          </div>
          <div className="values__grid">
            {t.values.map((v, i) => (
              <div key={i} className="value-card">
                <div className="value-card__icon">{valueIcons[i]}</div>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="team section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">{t.teamTag}</span>
            <h2 className="section-title">
              {t.teamTitle1} <span className="gradient-text">{t.teamTitle2}</span>
            </h2>
          </div>
          <div className="team__grid">
            {t.team.map((member, i) => (
              <div key={i} className="team-card">
                <div className="team-card__avatar" style={{ background: `${teamColors[i]}22`, border: `1px solid ${teamColors[i]}40` }}>
                  <span style={{ color: teamColors[i], fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: '1.5rem' }}>
                    {member.name.split(' ').map(n => n[0]).join('')}
                  </span>
                </div>
                <h3 className="team-card__name">{member.name}</h3>
                <p className="team-card__role">{member.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="cta-box">
            <div className="cta-box__glow" />
            <h2 className="cta-box__title">{t.ctaTitle}</h2>
            <p className="cta-box__desc">{t.ctaDesc}</p>
            <div className="cta-box__actions">
              <Link to="/contact" className="btn-primary">{t.getInTouch} <ArrowRight size={16} /></Link>
              <a href="#careers" className="btn-outline">{t.openRoles}</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
